
<ng-container *ngIf="!!featureTags && featureTags['sf_nos_to_unit']">
    <div fxLayout="row">
        <h1 mat-dialog-title fxFlex class="popup-title">{{title}}</h1>
        <div fxFlex class="text-end">
            <button mat-mini-fab color="warn" (click)="close()"><i class="material-icons" data-icon="close"></i>
            </button>
        </div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div mat-dialog-content class="cart-dialog">
        <div class="product" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
            <div class="product-img">
                <img src="data:,"
                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                    imgType="products" imgSize="xs" imagePreload
                    alt="{{product['description'] ? product['description'] : product['product']['description']}}" />
            </div>
            <div class="product-content" fxLayout="column">
                <h3 class="title">
                    <span *ngIf="product['description']">{{product['description']}}</span>
                    <span *ngIf="!product['description']">{{product['product']['description']}}</span>
                </h3>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div class="p-1">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <span></span>
                <ng-container *ngIf="!!featureTags && !featureTags['sf_average_size_message']">
                    <span fxLayoutAlign="end" fxFlex="50%" fxFlex.lt-sm="70"
                    *ngIf="!!this.product['product']['sell_in_uof'] && this.product['product']['sell_in_uof'] === 'unit'"
                    class="ft-12">(Average size of 1 qty is {{product['product']['sell_in_conv_rate']}} {{product['product']['cb_unit_of_measurement']['acronym']}}))</span>
                </ng-container>
                <ng-container *ngIf="!!featureTags && featureTags['sf_average_size_message']">
                    <span fxLayoutAlign="end" fxFlex="50%" fxFlex.lt-sm="70"
                    *ngIf="!!this.product['product']['sell_in_uof'] && this.product['product']['sell_in_uof'] === 'unit'"
                    class="ft-12">(Average size is {{product['product']['sell_in_conv_rate']}} {{product['product']['cb_unit_of_measurement']['acronym']}})</span>
                </ng-container>
                
            </div>
    
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <span fxFlex>Quantity</span>
                <div fxLayout="column" fxFlex="50%" fxFlex.gt-md="210px" fxFlex.lt-sm="70">
                    <mat-form-field appearance="outline" class="customize-mat-form-field reduce-mat-form-field-height">                    
                            <mat-select [formControl]="quantityControl" (openedChange)="onOpenedChange($event)" (selectionChange)="quantityValidation($event)">
                                <mat-option *ngFor="let quantity of displayedQuantities;let i = index" [value]="quantity"
                                    (onSelectionChange)="onQuantityChange($event)">
                                    {{ (product['product']['sell_in_uof'] === 'unit' && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs') ? quantity : quantity }}
                                    <span *ngIf="!!product['product']['cb_unit_of_measurement']['acronym']">
                                        <span
                                            *ngIf="(!!this.product['product']['sell_in_uof'] === false ||  (!!this.product['product']['sell_in_uof'] && this.product['product']['sell_in_uof'] !== 'unit' ) ) ">{{product['product']['cb_unit_of_measurement']['acronym']}}</span>
                                        <span
                                            *ngIf="!!this.product['product']['sell_in_uof'] && this.product['product']['sell_in_uof'] === 'unit' ">unit</span>
                                    </span>
                                </mat-option>        
                            </mat-select>                            
                        <mat-error *ngIf="quantityControl.hasError('required')">Please choose a quantity</mat-error>
                    </mat-form-field>
                </div>    

            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="seasonalProductEvents.length==0">
                <span fxFlex>Frequency</span>
                <!-- <div class="frequency-align">                 -->
                <mat-form-field appearance="outline" fxFlex.lt-sm="70" fxFlex.gt-md="210px"
                    class="customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="frequencyControl" #freqSelect required (selectionChange)="frequencyValidation($event)">
                        <mat-option *ngFor="let option of frequencies" [value]="option">
                            {{ option.viewValue }}
                            <span *ngIf="option.frequency === 'One Time Only' && !!option.event_id">
                                - {{ option.event_date | date: 'MMM d' }}
                            </span>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="freqSelect.errorState && frequencyControl.hasError('required')">
                        Please choose a frequency
                    </mat-error>
                </mat-form-field>
                    <!-- <div *ngIf="frequencyMsg !=''" class="error-message">{{frequencyMsg}}</div> -->
                <!-- </div> -->
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" *ngIf="seasonalProductEvents.length==0">
                    <div *ngIf="frequencyMsg !=''" class="error-message">{{frequencyMsg}}</div>
            </div> -->
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="isStartDate">
                <span fxFlex>Start Date</span>
                <!-- <div class="frequency-align"> -->
                <!-- Single-Select Dropdown -->
                <mat-form-field *ngIf="!isMultiSelect" appearance="outline" fxFlex.lt-sm="70" fxFlex.gt-md="210px"
                    class="customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="startDateControl" #dateSelect required (selectionChange)="startDateValidation($event)">
                            <mat-option *ngFor="let startDates of eventDates" [value]="startDates">
                                {{startDates.event_date | date: 'MMM d'}}
                            </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dateSelect.errorState && startDateControl.hasError('required')">
                        Please choose a frequency
                    </mat-error>
                </mat-form-field>

                <!-- Multi-Select Dropdown -->
                <mat-form-field *ngIf="isMultiSelect" appearance="outline" fxFlex.lt-sm="70" fxFlex.gt-md="210px"
                    class="customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="startDateControl" #dateSelect required multiple placeholder="Select Date" (selectionChange)="onMultipleSelectChange($event)">                        
                        <mat-option *ngFor="let startDates of eventDates" [value]="startDates">
                            {{ startDates.event_date | date: 'MMM d' }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dateSelect.errorState && startDateControl.hasError('required')">
                        Please choose one or more dates
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="seasonalProductEvents.length>0">
                <span>Estimated Delivery</span>
                <mat-form-field appearance="outline" fxFlex.lt-sm="70"
                    class="customize-mat-form-field reduce-mat-form-field-height">
                    <mat-select [formControl]="seasonalEventsControl" #eventSelect required>
                        <mat-option *ngFor="let events of seasonalProductEvents" [value]="events['event_delivery_date']">
                            {{events['formated_event_date']}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="eventSelect.errorState && seasonalEventsControl.hasError('required')">Please choose a
                        estimated delivery</mat-error>
                </mat-form-field>
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="p-1">
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center start">
                <p class=" text-muted " fxShow="false" fxShow.lt-md="true" *ngIf="!!product['product'].compare_price">
                    <span class="old-price">{{storeDetails['currency']}}
                        <span
                            *ngIf="!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit'">{{((product['product']['compare_price'] *  quantityControl.value) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}
                        </span>
                        <span
                            *ngIf="(!!product['product']['sell_in_uof'] === false || (!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] !== 'unit') )">{{((product['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}
                        </span>
                    </span> Saved ({{product['product'].savepercentage}}%)</p>
                <h3 class="price">
                    {{storeDetails['currency']}}                    
                    <span
                        *ngIf=" !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit'">{{((product['product']['unit_retail_price'] *  quantityControl.value ) | number: '1.2-4' | replacecomma)  | number: '1.2-2'}}</span>
                    <span
                        *ngIf="(!!product['product']['sell_in_uof'] === false || (!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] !== 'unit') )">
                        {{((product['product']['retail_price'] *  quantityControl.value) | number: '1.2-4' | replacecomma)  | number: '1.2-2'}}
                    </span>
                </h3>
                <p class=" text-muted pd-l-5" fxShow="false" fxShow.gt-sm="true" *ngIf="!!product['product'].compare_price">
                    <span class="old-price">{{storeDetails['currency']}}
                        <span
                            *ngIf="!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit'">{{((product['product']['compare_price'] *  quantityControl.value) | number: '1.2-4' | replacecomma)  | number : '1.2-2'}}
                        </span>
                        <span
                            *ngIf="(!!product['product']['sell_in_uof'] === false || (!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] !== 'unit') )">{{((product['product'].compare_price  *  quantityControl.value) | number: '1.2-4' | replacecomma) | number : '1.2-2'}}
                        </span>
                    </span> Saved ({{product['product'].savepercentage}}%)</p>
            </div>
    
            <div class="product-action">
                <ng-container *ngIf="!!featureTags && featureTags['sf_out_of_stock']; else noOutOfStock">
                    <button *ngIf="seasonalProductEvents.length==0 && !!product['product']['stock_info'] && (product['product']['stock_info']['restrict_orders'] == 0 || (product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']!=0))"
                        [disabled]="isButtonDisabled" mat-raised-button (click)="saveOrderFunction()" class="btn-add" id="addToCart">
                        Add to Order
                    </button>
                    <button *ngIf="seasonalProductEvents && seasonalProductEvents.length>0 && !!product['product']['stock_info'] && (product['product']['stock_info']['restrict_orders'] == 0 || (product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']!=0))" mat-raised-button (click)="buySeasonalProduct()"
                        [options]="addToSeasonalProductButtonOptions" color="primary" id="preOrder">
                        Pre-Order Now
                    </button>
                    <button *ngIf="!!product['product']['stock_info'] && product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']==0"
                    [options]="outOfStockButtonOptions" disabled="true" mat-raised-button class="btn-add" id="outofstock">
                        Sold Out
                    </button>
                </ng-container>
                <ng-template #noOutOfStock>
                    <mat-spinner-button *ngIf="product['cart'] === '' && product['msg'] === 2 && seasonalProductEvents.length==0"
                        [options]="addToCartButtonOptions" [disabled]="isButtonDisabled" mat-raised-button (click)="saveOrderFunction()" class="btn-add" id="addToCart">
                        Add to Order
                    </mat-spinner-button>
                    <mat-spinner-button *ngIf="(product['cart'].length === 0 || product['cart']['recurring'] === 1) && loggegIn === true && seasonalProductEvents.length==0"
                        [options]="addToCartButtonOptions" [disabled]="isButtonDisabled" mat-raised-button (click)="saveOrderFunction()" class="btn-add" id="addToCart">
                        Add to Order
                    </mat-spinner-button>
                    <mat-spinner-button *ngIf="seasonalProductEvents && seasonalProductEvents.length>0" mat-raised-button (click)="buySeasonalProduct()"
                        [options]="addToSeasonalProductButtonOptions" color="primary" id="preOrder">
                        Pre-Order Now
                    </mat-spinner-button>
                </ng-template>
            </div>
        </div>
    </div>
</ng-container>
